import { BankHolidaysResponse } from '../lib/types';

const BANK_HOLIDAYS_URL = 'https://www.gov.uk/bank-holidays.json';

export const fetchBankHolidays = async (): Promise<{
  data: BankHolidaysResponse | null;
  error: string | null;
}> => {
  try {
    const response = await fetch(BANK_HOLIDAYS_URL);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data: BankHolidaysResponse = await response.json();

    return {
      data,
      error: null
    };
  } catch (error) {
    return {
      data: null,
      error: (error as Error).message || 'Unknown error'
    };
  }
};
